module.exports = __webpack_public_path__ + "img/dl.2d766770.png";